export function textDefault(value, defaultValue = 'Не указано') {
    if (typeof (defaultValue) !== 'string')
        throw new Error('Parameter [2] is not a string');

    if (value == null)
        return defaultValue;

    if (typeof (value) === 'string' && value.trim() === '')
        return defaultValue;

    return value;
}
